export const defaultState = {
  scholarshipCombinations: [],
  scholarshipCourses: [],
  scholarshipRequests: [],
  scholarshipDocuments: [],
  scholarshipRequestAttachments: [],
  scholarshipRequestLogs: [],
  eligibility: {},
  scholarshipSummary: {},
  scholarshipAppeals: [],
  scholarshipSchedule: null,
  scholarshipAppealSettings: null,
};
